<script lang="ts" setup>
	withDefaults(
		defineProps<{
			showHeader?: boolean
			title?: string
			subTitle?: string
			wrapperClass?: ClassContext
			parentClass?: ClassContext
			subTitleClass?: ClassContext
			useFixedHeader?: boolean
			fixedClass?: ClassContext
			titleFixedClass?: ClassContext
			headerClass?: ClassContext
			titleClass?: ClassContext
			disableBtn?: boolean
			btnRelative?: boolean
		}>(),
		{
			titleFixedClass: 'md:pt-12 sm:mt-8',
			parentClass: 'mt-10',
			disableBtn: false,
			showHeader: true
		}
	)
	const emit = defineEmits<{
		(arg: 'back'): void
	}>()
</script>

<template>
	<div>
		<shared-wrapper
			:disable-btn="disableBtn"
			class="sm:max-w-[91.666667%] sm:px-5"
			btn-class="z-10"
			:class="(showHeader && parentClass) || ''"
			:fixed-class="(showHeader && fixedClass) || ''"
			:use-fixed-header="useFixedHeader"
			:btn-relative="btnRelative"
			@back="emit('back')"
		>
			<template #header>
				<div v-show="showHeader">
					<div v-if="useFixedHeader" class="w-full" :class="titleFixedClass" />
					<slot name="header">
						<shared-header
							:title="title || ''"
							:sub-title="subTitle || ''"
							:title-class="titleClass"
							:sub-title-class="subTitleClass"
							class="text-center"
							:class="headerClass"
						/>
					</slot>
				</div>
			</template>
			<div :class="wrapperClass">
				<slot />
			</div>
		</shared-wrapper>
	</div>
</template>
